import React from 'react';
import { domToReact } from 'html-react-parser';
import styled from 'styled-components';

const StyledH1 = styled.h1`
  color: #212529;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 3rem;
  text-transform: capitalize;
`;

const h1TagRenderer = (node) => {
  const { children, options } = node;

  return (<StyledH1>
    {domToReact(children, options)}
  </StyledH1>);
};

export default h1TagRenderer;
